<template>
	<div class="section-header">
		<div class="title_page">{{title}}</div>
	</div>
</template>
<script>
	export default{
		props: ['title']	
	};
	
</script>
<style lang="scss" scoped>
	@import "./header_section"
</style>


// WEBPACK FOOTER //
// src/views/components/Common/HeaderSection.vue